/* import __COLOCATED_TEMPLATE__ from './radio-button.hbs'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { isEqual } from '@ember/utils';
let RadioButtonComponent = (_class = class RadioButtonComponent extends Component {
  // value - passed in, required, the value for this radio button
  // groupValue - passed in, required, the currently selected value

  // optionally passed in:
  // disabled - boolean
  // required - boolean
  // name - string
  // radioClass - string
  // radioId - string
  // ariaLabelledby - string
  // ariaDescribedby - string

  get joinedClassNames() {
    const classNames = this.args.classNames;
    if (classNames && classNames.length && classNames.join) {
      return classNames.join(' ');
    }
    return classNames;
  }
  get checkedClass() {
    return this.args.checkedClass || 'checked';
  }
  get checked() {
    return isEqual(this.args.groupValue, this.args.value);
  }
  changed(newValue) {
    let changedAction = this.args.changed;

    // providing a closure action is optional
    if (changedAction) {
      changedAction(newValue);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "changed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changed"), _class.prototype)), _class);
export { RadioButtonComponent as default };